import { ProgressCircular, Navbar } from 'backoffice-react-components';
import React, { Suspense, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Box, Container, Hidden } from '@mui/material';
import useMediaQuery from '../hooks/useMediaQuery';
import { RootState } from '../redux/combineReducer';
import { configurationSliceActions } from '../redux/slices/configuration.slice';
import routes from './routes';
import FeedbackScreen from '../components/FeedbackScreen/FeedbackScreen';
import { WHATSAPP_LINK } from '../utils/constants/configurations';
import getImagePath from '../utils/helpers/getImagePath';
import { BACKGROUND_FPAY_BLUE, FPAY_LOGO } from '../utils/constants/images';
import ErrorBoundary from '../utils/components/ErrorBoundry';
import { categorySliceActions } from '../redux/slices/category.slice';
import { AppThunkDispatch } from '../redux/store';
import { authSliceActions } from '../redux/slices/auth.slice';

const pages = ['Products', 'Pricing', 'Blog'];
const settings = ['Profile', 'Account', 'Dashboard', 'Logout'];
const eslogan = 'SÚMATE ES SIMPLE';

export const Navigation = () => {
  const matchMD: Boolean = useMediaQuery('md');
  const dispatch = useDispatch<AppThunkDispatch>();
  const configuration = useSelector((state: RootState) => state.configuration);
  const category = useSelector((state: RootState) => state.category);
  const auth = useSelector((state: RootState) => state.auth);
  const { pathname } = useLocation();

  useEffect(() => {
    dispatch(configurationSliceActions.getConfiguration());
    dispatch(categorySliceActions.findAllCategory());
  }, []);

  useEffect(() => {
    if (configuration.status === 'success') dispatch(authSliceActions.findOneCookie(configuration.cookieNameAuth || ''));
  }, [configuration.cookieNameAuth]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  const onClickWhatsapp = () => {
    window.open(WHATSAPP_LINK);
  };

  return configuration.status !== 'success' || (category.status !== 'success' && category.categories.length === 0) || auth.status !== 'success' ? (
    <>
      {configuration.status === 'loading' ||
      (category.status === 'loading' && category.categories.length === 0) ||
      auth.status === 'loading' ||
      (auth.status === 'inactive' && (configuration.status !== 'error' || category.status !== 'error')) ? (
        <ProgressCircular title="Cargando información" subtitle="Solo serán unos segundos" isMobile={matchMD} size={40} />
      ) : (
        <Box>
          <FeedbackScreen status="REJECTED" onClick={onClickWhatsapp} />
        </Box>
      )}
    </>
  ) : (
    <Suspense fallback={<ProgressCircular title="Cargando información" subtitle="Solo serán unos segundos" isMobile={matchMD} size={40} />}>
      <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
        {/* DESKTOP */}
        <Hidden mdDown>
          <Navbar
            pages={pages}
            settings={settings}
            eslogan={eslogan}
            logo={getImagePath(FPAY_LOGO)}
            backgroundUrl={getImagePath(BACKGROUND_FPAY_BLUE)}
          />
        </Hidden>
        <ErrorBoundary>
          <Container sx={{ display: 'flex', flexDirection: 'column', flex: 1, minHeight: '100%' }}>
            <Routes>
              {routes.map(({ path, component: Component }) => (
                <Route key={path} path={path} element={<Component />} />
              ))}
              <Route path="/*" element={<Navigate to={routes[0].to} replace />} />
            </Routes>
          </Container>
        </ErrorBoundary>
      </Box>
    </Suspense>
  );
};
